import { createAsyncThunk } from '@reduxjs/toolkit';
import type { GetServerSidePropsContext } from 'next';

import type { AppGetState } from 'redux-store';

import doFetch from 'utils/doFetch';

const getProductsV3Thunk = createAsyncThunk(
  'products/getProductsV3',
  async (
    {
      context,
      screen,
      coupon,
    }: { context: GetServerSidePropsContext; screen: string; coupon?: string },
    { getState },
  ) => {
    try {
      const apiPointName = 'getProductsV3';

      let headers = {};

      if (context.req.headers['accept-language']) {
        headers = {
          ...headers,
          'accept-language': context.req.headers['accept-language'],
        };
      }

      const store = (getState as AppGetState)();
      const token = store.jwt.token;

      if (token) {
        headers = {
          ...headers,
          Authorization: `Bearer ${token}`,
        };
      }

      return await doFetch<typeof apiPointName>({
        apiPointName,
        context,
        body: null,
        queryParams: {
          screen,
          coupon_code: coupon,
        },
        headers,
      });
    } catch (err) {
      const errorToReject = err instanceof Error ? err : new Error(typeof err === 'object' ? JSON.stringify(err, null, 2) : String(err));
      console.error({ errorToReject });

      return Promise.reject(errorToReject);
    }
  },
);

export default getProductsV3Thunk;
